import { pl, t, toWireDate } from "@hakili/i18n";

/** `P1-DLW-048`: the dossier list's and the Accueil's age words, from the SERVED `since` and the SERVER's day (`OD-17`: no front application owns a clock). */
/** The Bamako day of an instant, AAAA-MM-JJ (`new Date(value)` converts something already known; it reads no clock). */
export const dayOf = (instant: string): string => toWireDate(new Date(instant));

/** « depuis 4 jours », from the served `since` and the server's day. Both are calendar days, so the gap is whole. */
export const sinceWords = (since: string, today: string | null): string | null => {
  if (today === null) return null;
  const days = Math.max(
    0,
    Math.trunc((Date.parse(`${today}T00:00:00Z`) - Date.parse(`${dayOf(since)}T00:00:00Z`)) / 86_400_000),
  );
  return days === 0
    ? t("dealer.dossiers.depuisAujourdhui")
    : t("dealer.dossiers.depuis")
        .split("{duree}")
        .join(pl(days, t("dealer.dossiers.jour"), t("dealer.dossiers.jours")));
};
